import React from 'react';

import {
  BodyText,
  OfflineContainer,
  TextContainer,
  Title,
} from './AppOffline.styles';

export const AppOffline = () => {
  const currentLanguage = navigator.language || navigator.languages[0];

  return (
    <OfflineContainer>
      <TextContainer id="offlineAppContainer">
        <Title variant="h3">
          {currentLanguage === 'pt-PT'
            ? 'Site em manutenção'
            : 'Site under maintenance'}
        </Title>
        <BodyText>
          {currentLanguage === 'pt-PT'
            ? 'Estamos atualmente em manutenção. Pedimos desculpa pelo incómodo e agradecemos a sua paciência.'
            : 'We are currently under maintenance. We apologize for the inconvenience and thank you for your patience.'}
        </BodyText>
        <BodyText>
          {currentLanguage === 'pt-PT'
            ? 'Por favor, volte mais tarde.'
            : 'Please come back later.'}
        </BodyText>
      </TextContainer>
    </OfflineContainer>
  );
};

export default AppOffline;
